export default __webpack_public_path__ + "static/media/app-showcase-image-01.d55f5bdf.png";